
const digest = 'b651a5a8a0f0676fac7ccda7ad5443f0358a29bd82138a4a02104642ac777d2a';
const classes = {"wrapper":"_wrapper_11rae_1","buttons":"_buttons_11rae_7"};
const css = `._wrapper_11rae_1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

._buttons_11rae_7 {
  display: flex;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  